<template>
    <input
      type="text"
      :value="value"
      placeholder="Enter String"
      
    />
  </template>
  
  <script>
  export default {
    props: {
      value: {
        type: String,
        default: '',
      },
    },
  }
  </script>